import { IS_SAAS } from '../config/edition';
import { isEmployee } from './roles';

// Ящик bit-calendar: приглашение в Outlook на этот адрес — и бот приходит на
// встречу сам (на проде с 17.10.2026, Deploy Prod 116736). Спека:
// docs/superpowers/specs/2026-10-16-calendar-invite-bot-design.md
export const CALENDAR_BOT_EMAIL = 'newton@1cbit.ru';

// Кому показывать подсказку в форме бота (решение Владимира 19.10.2026).
// 🔴 Только сотрудникам: приглашения с внешних адресов (Gmail, Яндекс)
// bit-calendar пока отклоняет — CALENDAR_DMARC_AUTHSERV_ID пуст, — и клиенту
// подсказка обещала бы то, что не сработает. Включим, когда задан authserv-id.
// В onprem нашего ящика у клиента нет вовсе.
// 🔴 И только с почтой 1cbit.ru, хотя сотрудники приходят ещё с ~14 доменов
// группы: bit-calendar верит лишь письму, прошедшему через Exchange 1cbit
// (AuthAs: Internal, bit-calendar/app/authenticity.py). Какие из доменов живут
// в той же организации Exchange, не проверено; проверено живой встречей — 1cbit.ru.
const STAFF_MAIL_DOMAIN = '1cbit.ru';

export const showCalendarHint = (role, email) => IS_SAAS && isEmployee(role)
  && typeof email === 'string' && email.toLowerCase().endsWith(`@${STAFF_MAIL_DOMAIN}`);
